import { BigNumber } from 'ethers'

import { renderAmount, toAmount } from '~/lib/helpers'
import { SIS_DECIMALS } from '~/lib/SISDecimals'

export const CROSSFARMING_DOCUMENTATION_HREF =
	'https://docs.symbiosis.finance/liquidity-providers/cross-chain-farming'
export const LP_FARMING_DOCUMENTATION_HREF =
	'https://docs.symbiosis.finance/liquidity-providers/how-to-stake'

export function getFormattedSISValue(value?: string): string {
	if (!value) {
		return '0 SIS'
	}

	let sisValue
	try {
		const amount = toAmount(SIS_DECIMALS, BigNumber.from(value))
		sisValue = `${renderAmount(amount, 6)} SIS`
	} catch (error) {
		console.warn(error)
	}

	return sisValue || '0 SIS'
}
